import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd';
import { PrescriptionService } from '../../services/prescription.service';

@Component({
  selector: 'app-modal-search',
  templateUrl: './modal-search.component.html',
  styleUrls: ['./modal-search.component.scss']
})
export class ModalSearchComponent implements OnInit {
  constructor(
    private router: Router,
    public modalRef: BsModalRef,
    private notification: NzNotificationService,
    private prescriptionService: PrescriptionService
  ) {}

  ngOnInit() {}

  search(param: string) {
    param = param === undefined ? '' : param.replace(/[^a-z0-9]+/gi, '');
    if (param === '') {
      this.modalRef.hide();
      this.notification.warning('Atenção', 'CPF ou Código da Receita não informado');
    } else if (param.length === 11 || param.length === 15) {
      this.requests(param);
    } else {
      this.modalRef.hide();
      this.notification.warning('Atenção', 'CPF ou código inválido');
    }
  }

  private async requests(param: string) {
    try {
      const prescriptions = await this.prescriptionService.getPrescriptionsPatient(param).toPromise();

      if (param.length === 11) {
        if (prescriptions.length === 0) {
          this.notification.warning(
            'Atenção',
            'Não existe prescrições com medicamentos a serem dispensados para o CPF informado'
          );
          return;
        }

        this.router.navigate(['/prescription/listing-prescriptions/', param], {
          state: { prescriptions: prescriptions }
        });
      } else {
        this.router.navigate(['/prescription/confirmation', param], {
          state: { prescription: prescriptions }
        });
      }
      this.modalRef.hide();
    } catch (error) {
      this.modalRef.hide();
      if (error.status === 404) {
        this.notification.warning('Atenção', error.error.message);
      }
    }
  }
}
